import React from 'react';
import styled from 'styled-components';

// @ts-ignore
const CurrencyIcon = ({ opacity = 1, fill = '#000', width = 7, height = 9, bold = false }) => {
  const { Widget } = window;
  const { currencyIcon } = Widget.settings;

  if (currencyIcon) {
    return <IconImage src={currencyIcon} height={height} color={fill} />;
  }
  return !bold ? (
    <span>₽</span>
  ) : (
    <svg width="10" height="10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.599 8.42H3.397V10H1.675V8.42H.273V7.034h1.402v-.731H.273V4.914h1.402V.047h3.807c1.099 0 1.976.287 2.632.861.657.57.985 1.329.985 2.277 0 .966-.313 1.725-.937 2.276-.624.547-1.492.827-2.604.84h-2.16v.732h2.2v1.388zM3.397 4.915h2.058c.62 0 1.094-.143 1.422-.43.328-.288.492-.716.492-1.286 0-.51-.162-.927-.485-1.25-.32-.324-.761-.493-1.326-.507h-2.16v3.473z"
        fill={fill}
        opacity={opacity}
      />
    </svg>
  );
};

export default CurrencyIcon;

const IconImage = styled.img`
  display: inline;
  vertical-align: baseline;
  height: ${(props) => props.height}px;
  filter: ${(props) => (props.color === '#fff' ? 'brightness(0) invert(1)' : 'initial')};
`;
